import angular from 'angular';
import { NextStepConfig } from './next-step.config';
import { NewProductIntroModule } from '../new-product-intro';
import './next-step.global.css';

export const NextStepModule = angular
  .module('app.next-step', [NewProductIntroModule.name])
  .config(NextStepConfig);
